import React from 'react';

import { useAppSelector } from 'redux/hooks';
import type { IframePage } from "types/iframe";
import { withParamsFrame } from 'HOCs';

const Offer: React.FC<IframePage> = ({ params }) => {
    const [httpParams] = React.useState(params);

    const { sellerId } = useAppSelector(({ sellers }) => ({
        sellerId: sellers.currentSeller.info.data?.id,
    }))

    return (
        <>
            <div className='xs:mx-3'>
                <iframe className={'page-iframe'} src={`https://lk.market/${sellerId}/offers${httpParams}`}
                    title="Offers"
                    width="100%"
                    height={"calc(100vh-64px)"}
                ></iframe>
            </div>
        </>
    );
};

export default withParamsFrame(Offer);
